import React from 'react';
import PropTypes from 'prop-types';
import naturalCompare from 'natural-compare-lite';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import Chip from 'material-ui/Chip';
import { chipsStyle } from '../../../theme/AllocateBaseTheme';
import globals from '../../../globals/communityGlobals';
import { lowerFirstLetter } from '../../../utils/helpers';

const treatmentslocal = globals.getArea('treatments');

class NestedSelectorChips extends React.Component {
  state = {
    value: 1,
  };

  handleChange = (id, event, key, newValue, option) => {
    this.setState({ value: newValue });
    const { onChipChange } = this.props;
    onChipChange(id, event, key, newValue, option);
  };

  selectionRender = (value, menuitem) => {
    const {
      props: { primaryText },
    } = menuitem;
    return primaryText === treatmentslocal.getMsg('defaultAvf')
      ? ''
      : `${primaryText} ${treatmentslocal.getMsg('avfLabel')}`;
  };

  hasActivityFactors = searchId => {
    const { options } = this.props;
    if (options.find(o => o.id === searchId).activityVariances.length > 0) {
      return true;
    }
    return false;
  };
  generateSortedChipsMap = () => {
    const { value, options } = this.props;
    const chipsMap = value
      .filter(v => options.find(o => o.id === v.id) !== undefined)
      .map(v => ({
        id: v.id,
        name: v.name,
        innerId: v.innerId,
        ragStatus: v.ragStatus,
        band: v.band,
      }));
    return chipsMap.sort((a, b) => naturalCompare(a.name, b.name));
  };

  generateSortedSubitems = searchId => {
    const { options } = this.props;
    const items = [];
    const variances = options.find(o => o.id === searchId).activityVariances;
    items.push(
      <MenuItem value={-2} key={-2} disabled selected={false} primaryText={treatmentslocal.getMsg('avfHeader')} />,
    );
    items.push(<MenuItem value={-1} key={null} selected primaryText={treatmentslocal.getMsg('defaultAvf')} />);
    items.push(
      variances.map(({ id, value }) => (
        <MenuItem value={id} key={`Key${id + value}`} primaryText={` ${value} ${treatmentslocal.getMsg('mins')}`} />
      )),
    );
    return items;
  };

  render() {
    const sortedChipsMap = this.generateSortedChipsMap();
    const { disabled, handleRequestDelete, localeArea } = this.props;
    const locale = localeArea ? globals.getArea(localeArea) : {};
    return (
      <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', float: 'left' }}>
        {sortedChipsMap.map(({ id, name, innerId }) => (
          <Chip
            style={chipsStyle.style}
            onRequestDelete={!disabled ? handleRequestDelete(id) : null}
            key={`selectorChip${name + id}`}
          >
            <SelectField
              name={`InnerSelector${name + id}`}
              key={`selectorChip${name + id}`}
              value={innerId}
              onChange={(event, key, newValue, option) => this.handleChange(id, event, key, newValue, option)}
              underlineStyle={{ display: 'none' }}
              labelStyle={{ top: 0, height: 32, lineHeight: '32px', paddingRight: 40, fontWeight: 500 }}
              style={{ verticalAlign: 'middle', fontSize: '1.3rem', height: 32, width: 'auto' }}
              iconStyle={{ fill: '#000', padding: '4px 7px', height: 32, right: 3 }}
              autoWidth
              selectionRenderer={this.selectionRender}
              disabled={!this.hasActivityFactors(id)}
            >
              {this.generateSortedSubitems(id)}
            </SelectField>
            <span>{localeArea ? locale.getMsg(lowerFirstLetter(name)) : name}</span>
          </Chip>
        ))}
      </div>
    );
  }
}

NestedSelectorChips.defaultProps = {
  value: null,
  options: null,
  disabled: false,
  localeArea: '',
  onChipChange: () => {},
};

const optionPropType = PropTypes.shape({
  id: PropTypes.number,
  value: PropTypes.number,
  name: PropTypes.string,
  innerId: PropTypes.number,
});

NestedSelectorChips.propTypes = {
  options: PropTypes.arrayOf(optionPropType),
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number,
        innerId: PropTypes.number,
      }),
    ),
  ]),
  handleRequestDelete: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  localeArea: PropTypes.string,
  onChipChange: PropTypes.func,
};

export default NestedSelectorChips;
